// dataflow.service.ts
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DataflowService {
  private base = `${environment.Server_URL}/dataflows`;

  constructor(private http: HttpClient) {}

  /** Get paginated list */
  getAll(perPage = 10, page = 1): Observable<any> {
    const params = new HttpParams()
      .set('per_page', perPage)
      .set('page', page);
    return this.http.get<any>(this.base, { params });
  }

  /** Get one by ID */
  getById(id: number): Observable<any> {
    return this.http.get<any>(`${this.base}/${id}`);
  }

  /** Create new record with optional PDF */
  create(payload: any, pdfFile?: File): Observable<any> {
    const formData = payload;
    return this.http.post<any>(this.base, formData);
  }

  // /** Update record with optional PDF */
  // update(id: number, payload: any, pdfFile?: File): Observable<any> {
  //   const formData = this.buildFormData(payload, pdfFile);
  //   return this.http.post<any>(`${this.base}/${id}`, formData);
  //   // ملاحظة: استخدم POST أو PATCH حسب ما ضبطت الـ API في Laravel
  // }
update(id: number, payload: FormData | any): Observable<any> {
  if (payload instanceof FormData) {
  // ✨ Laravel هيشوفه PUT
    return this.http.post(`${this.base}/${id}`, payload);
  }

  return this.http.put(`${this.base}/${id}`, payload, {
    headers: { 'Content-Type': 'application/json' }
  });
}

  /** Delete record */
  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.base}/${id}`);
  }

  /** Search records */
  search(q = '', page = 1, perPage = 10): Observable<any> {
    let params = new HttpParams()
      .set('page', page)
      .set('per_page', perPage);
    if (q) params = params.set('q', q);
    return this.http.get<any>(`${this.base}/search`, { params });
  }

  /** Helper: Build FormData for payload + optional PDF */
  private buildFormData(payload: any, pdfFile?: File): FormData {
    
    const formData = new FormData();
    Object.keys(payload).forEach((key) => {
      if (payload[key] !== null && payload[key] !== undefined) {
        formData.append(key, payload[key]);
      }
    });
    if (pdfFile) {
      formData.append('request_pdf', pdfFile);
    }
    return formData;
  }
}
